import React from 'react';
import { unSparse } from '../../../../../../scripts/utils';
import { PageSearchResultItem } from '../../../PageSearchResultItem/PageSearchResultItem';
import { ResultProps } from '../../resultProps';

export const SalesforceCaseResult: React.FC<ResultProps> = ({ result }) => {
  return (
    <PageSearchResultItem
      appName="Salesforce Case"
      breadcrumbs={unSparse(result.company_name, result.contact_name)}
      result={result}
      showLastItemBreadcrumb
    />
  );
};
